import type {
  AddTicketNoteRequestDTO,
  AddTicketNoteResponseDTO,
  DeleteNoteResponseDTO,
  EditTicketNoteRequestDTO,
  GetTicketDetailResponseDTO,
  SetTaskStateRequestDTO,
  SetTaskStateResponseDTO,
  Ticket,
  TicketNote,
  TicketPreview,
  UpdateTicketDueDateRequestDTO,
  UpdateTicketPriorityRequestDTO,
  UpdateTicketStatusRequestDTO,
  UpdateTicketTagsRequestDTO
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Ticketing/Ticketing.Controller.ts (access/{token} routes)
// Token-gated, anonymous — no orgId/ticketId, both come from the token itself.
export class TicketingAccessAPI {
  static async getTicket(token: string) {
    return APIService.Server.get<GetTicketDetailResponseDTO>(`/ticketing/access/${token}/ticket`);
  }

  static async getRelatedTickets(token: string) {
    return APIService.Server.get<{ tickets: TicketPreview[] }>(`/ticketing/access/${token}/related`);
  }

  static async updateStatus(token: string, body: UpdateTicketStatusRequestDTO) {
    return APIService.Server.put<{ ticket: Ticket }>(`/ticketing/access/${token}/status`, body);
  }

  static async updatePriority(token: string, body: UpdateTicketPriorityRequestDTO) {
    return APIService.Server.put<{ ticket: Ticket }>(`/ticketing/access/${token}/priority`, body);
  }

  static async updateTags(token: string, body: UpdateTicketTagsRequestDTO) {
    return APIService.Server.put<{ ticket: Ticket }>(`/ticketing/access/${token}/tags`, body);
  }

  static async updateDueDate(token: string, body: UpdateTicketDueDateRequestDTO) {
    return APIService.Server.put<{ ticket: Ticket }>(`/ticketing/access/${token}/due-date`, body);
  }

  static async setTaskState(token: string, taskId: number, body: SetTaskStateRequestDTO) {
    return APIService.Server.put<SetTaskStateResponseDTO>(`/ticketing/access/${token}/tasks/${taskId}/state`, body);
  }

  static async addNote(token: string, body: AddTicketNoteRequestDTO) {
    return APIService.Server.post<AddTicketNoteResponseDTO>(`/ticketing/access/${token}/notes`, body);
  }

  static async editNote(token: string, noteId: number, body: EditTicketNoteRequestDTO) {
    return APIService.Server.put<{ note: TicketNote }>(`/ticketing/access/${token}/notes/${noteId}`, body);
  }

  static async deleteNote(token: string, noteId: number) {
    return APIService.Server.delete<DeleteNoteResponseDTO>(`/ticketing/access/${token}/notes/${noteId}`);
  }

  static async mintTranscriptLink(token: string) {
    return APIService.Server.post<{ token: string }>(`/ticketing/access/${token}/transcript-link`, {});
  }
}
